<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShowing)="onShowingInternal()"
  (onHidden)="onHiddenInternal()"
  [closeOutsideClickEnabled]="false"
  modalTitle="Entidades"
  width="25rem"
  height="35rem"
>
  <ng-template modalContent>
    <div class="content">
      <app-input-box
        class="search-input"
        [value]="searchFilterTextSubject | async"
        (valueChange)="searchFilterTextSubject.next($event)"
        [showClearButton]="true"
        [showErrorEnabled]="false"
        placeholder="Pesquisar..."
      ></app-input-box>

      <div class="checkbox-all-select">
        <app-check-box
          class="checkbox"
          [(value)]="isAllSelected"
          label="Todos"
        ></app-check-box>
      </div>

      <div class="list-container">
        <app-list
          class="list"
          [items]="
            entityListFiltered
              | searchList
                : searchFilterValueListExpr
                : (searchFilterTextObservable | async)
          "
        >
          <ng-template listItem let-item="item">
            <div class="item">
              <app-check-box
                class="checkbox"
                [value]="isEntitySelected(item)"
                (valueChange)="setEntitySelected(item, $event)"
                [label]="item.name"
              ></app-check-box>
            </div>
          </ng-template>
        </app-list>
      </div>

      <div class="actions-bottom">
        <app-button
          buttonType="primary"
          styleType="contained"
          text="Aplicar"
          width="100%"
          (click)="onBtnApplyClick()"
        ></app-button>

        <app-button
          buttonType="normal"
          styleType="contained"
          text="Limpar"
          (click)="onBtnClearClick()"
          width="100%"
        ></app-button>
      </div>
    </div>
  </ng-template>
</app-modal>
